import { render, staticRenderFns } from "./devoirsDashLocal.vue?vue&type=template&id=957b9c08&"
import script from "./devoirsDashLocal.vue?vue&type=script&lang=js&"
export * from "./devoirsDashLocal.vue?vue&type=script&lang=js&"
import style0 from "./devoirsDashLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports